import React from "react";

const Table = () => {
    return (
        <div id="Table">
            <h3>Table</h3>

            <p>
                The table blocks listed below can be used to display and manipulate data in Table widgets.
            </p>

            <p>
                <strong>Select Row Value</strong> - This block returns the value in the selected column and row of the selected table.
            </p>
            <div className="imageContainer">
                <img src="/images/table_select_row.png" alt="Select Row Value" />
            </div>

            <p>
                <strong>Add to Table</strong> - Adds a record or row to the specified table. Once the table is selected, the block expands to include fields for each column.
            </p>
            <div className="imageContainer">
                <img src="/images/table_add_to.png" alt="Add to Table" />
            </div>

            <p>
                <strong>Set Column Name</strong> - Modifies the name of a particular column within the table.
            </p>
            <div className="imageContainer">
                <img src="/images/table_set_name.png" alt="Set Column Name" />
            </div>

            <p>
                <strong>Get Column Values</strong> - Retrieves the values under the specified column as a list.
            </p>
            <div className="imageContainer">
                <img src="/images/table_get_column.png" alt="Get Column Values" />
            </div>

            <p>
                <strong>Delete Rows</strong> - Deletes all rows in the specified table that meet the given conditions.
            </p>
            <div className="imageContainer">
                <img src="/images/table_deleteRow.png" alt="Delete Rows" />
            </div>

            <p>
                <strong>Refresh Table</strong> - Synchronizes the data in the table with the data from the linked API or database.
            </p>
            <div className="imageContainer">
                <img src="/images/table_refresh.png" alt="Refresh Table" />
            </div>

            <p>
                <strong>Run Edit</strong> - Saves changes made to a table row that is being edited. This corresponds to the 'Run Edit Records' action found in Events &gt; Actions.
            </p>
            <div className="imageContainer">
                <img src="/images/table_run_edit.png" alt="Run Edit" />
            </div>

            <p>
                <strong>Cancel Edit</strong> - Cancels changes made to a table row that is being edited. This aligns with the 'Cancel Edit Records' action in Events &gt; Actions.
            </p>
            <div className="imageContainer">
                <img src="/images/table_cancel_edit.png" alt="Cancel Edit" />
            </div>

            <p>
                <strong>Show/Hide Records</strong> - These blocks can be used to show or hide records in the designated table based on the specified conditions.
            </p>
            <div className="imageContainer">
                <img src="/images/table_show_record.png" alt="Show Record" />
            </div>
            <div className="imageContainer">
                <img src="/images/table_hide_record.png" alt="Hide Record" />
            </div>

            <p>
                <strong>Load Data from API</strong> - Retrieves data from a RESTful API endpoint and loads it into the indicated table. After selecting the table and entering connection details, click <em>Test</em>{' '}to verify the connection, then{' '}<em>Apply</em>{' '}in the test window. Additional dropdowns will appear, allowing you to map API response fields to table columns.
            </p>
            <div className="imageContainer">
                <img src="/images/table_load.png" alt="Load Data from API" />
            </div>
        </div>
    );
};

export default Table;
